import app from 'flarum/forum/app';
import Modal from 'flarum/common/components/Modal';
import Button from 'flarum/common/components/Button';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import Stream from 'flarum/common/utils/Stream';
import Avatar from 'flarum/common/components/Avatar';
import humanTime from 'flarum/common/helpers/humanTime';
export default class BanFromDiscussionModal extends Modal {
  activeTab = 'ban';
  searchRequestId = 0;
  // Id of the most recently *dispatched* (network-sent) search request.
  // Used purely to know whether a settling promise is the latest in-flight
  // call, so we can always clear the spinner for it — independent of
  // whether its results are still relevant to display (see searchRequestId).
  lastDispatchedRequestId = 0;
  searchTimeout = null;
  searchQuery = '';
  isDropdownDismissed = false;
  showResults = true;
  searchResults = [];
  searching = false;
  selectedUser = null;
  reason = (() => Stream(''))();
  loadingBans = false;
  bans = [];
  bansFilter = (() => Stream(''))();
  oninit(vnode) {
    super.oninit(vnode);
    this.searchRequestId++;
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout);
      this.searchTimeout = null;
    }
    this.isDropdownDismissed = false;
    this.showResults = false;
    this.searchQuery = '';
    this.searchResults = [];
    this.searching = false;
    if (this.attrs.preselectedUser) {
      this.selectedUser = this.attrs.preselectedUser;
    } else {
      this.selectedUser = null;
    }
    this.loadBans();
  }
  className() {
    return 'BanFromDiscussionModal Modal--medium';
  }
  title() {
    return app.translator.trans('huseyinfiliz-discussion-ban.forum.modal.title');
  }
  content() {
    return m("div", {
      className: "Modal-body BanFromDiscussionModal-body"
    }, m("div", {
      className: "BanFromDiscussionModal-tabs"
    }, m("button", {
      type: "button",
      className: 'BanFromDiscussionModal-tab' + (this.activeTab === 'ban' ? ' is-active' : ''),
      onclick: () => this.activeTab = 'ban'
    }, m("i", {
      className: "fas fa-user-plus"
    }), m("span", null, app.translator.trans('huseyinfiliz-discussion-ban.forum.modal.tab_ban'))), m("button", {
      type: "button",
      className: 'BanFromDiscussionModal-tab' + (this.activeTab === 'list' ? ' is-active' : ''),
      onclick: () => this.activeTab = 'list'
    }, m("i", {
      className: "fas fa-users"
    }), m("span", null, app.translator.trans('huseyinfiliz-discussion-ban.forum.modal.tab_list', {
      count: this.bans.length
    })))), this.activeTab === 'ban' ? this.banTab() : this.listTab());
  }
  banTab() {
    const query = this.searchQuery.trim();
    return m("div", {
      className: "BanFromDiscussionModal-content"
    }, m("div", {
      className: "Form-group"
    }, m("label", {
      className: "Form-label"
    }, app.translator.trans('huseyinfiliz-discussion-ban.forum.modal.select_user')), this.selectedUser ? m("div", {
      className: "BanFromDiscussionModal-selectedCard"
    }, m("div", {
      className: "BanFromDiscussionModal-selectedCard-user"
    }, m(Avatar, {
      user: this.selectedUser
    }), m("div", {
      className: "BanFromDiscussionModal-selectedCard-info"
    }, m("strong", null, this.selectedUser.displayName()), m("span", {
      className: "BanFromDiscussionModal-selectedCard-username"
    }, "@", this.selectedUser.username()))), m(Button, {
      className: "Button Button--icon Button--link",
      icon: "fas fa-times",
      title: app.translator.trans('huseyinfiliz-discussion-ban.forum.modal.change_user'),
      onclick: () => {
        this.selectedUser = null;
        this.clearSearch();
      }
    })) : m("div", {
      className: "BanFromDiscussionModal-search"
    }, m("div", {
      className: "BanFromDiscussionModal-searchInputWrapper"
    }, m("input", {
      className: "FormControl",
      type: "text",
      placeholder: String(app.translator.trans('huseyinfiliz-discussion-ban.forum.modal.search_placeholder')),
      oninput: e => this.onQueryInput(e.target.value),
      value: this.searchQuery
    }), this.searching && m("div", {
      className: "BanFromDiscussionModal-searchSpinner"
    }, m(LoadingIndicator, {
      size: "small"
    })), query.length > 0 && !this.searching && m(Button, {
      className: "Button Button--icon Button--link BanFromDiscussionModal-clearBtn",
      icon: "fas fa-times",
      onclick: () => this.clearSearch()
    })), !this.isDropdownDismissed && this.showResults && query.length >= 2 && this.searchResults.length > 0 && m("ul", {
      className: "BanFromDiscussionModal-results"
    }, this.searchResults.map(user => m("li", {
      key: user.id(),
      onclick: () => this.selectUser(user)
    }, m(Avatar, {
      user: user
    }), m("div", {
      className: "BanFromDiscussionModal-results-name"
    }, m("strong", null, user.displayName()), m("span", null, "@", user.username()))))))), m("div", {
      className: "Form-group"
    }, m("label", {
      className: "Form-label"
    }, app.translator.trans('huseyinfiliz-discussion-ban.forum.modal.reason_label')), m("textarea", {
      className: "FormControl",
      value: this.reason(),
      oninput: e => this.reason(e.target.value),
      rows: 3,
      placeholder: String(app.translator.trans('huseyinfiliz-discussion-ban.forum.modal.reason_placeholder'))
    }), m("div", {
      className: "helpText"
    }, app.translator.trans('huseyinfiliz-discussion-ban.forum.modal.reason_help'))), Button.component({
      className: 'Button Button--primary BanFromDiscussionModal-submitBtn',
      disabled: !this.selectedUser || this.loading,
      loading: this.loading,
      onclick: () => this.submit()
    }, app.translator.trans('huseyinfiliz-discussion-ban.forum.modal.submit')));
  }
  listTab() {
    if (this.loadingBans) {
      return m("div", {
        className: "BanFromDiscussionModal-loading"
      }, m(LoadingIndicator, null));
    }
    const filterText = this.bansFilter().trim().toLowerCase();
    const filteredBans = this.bans.filter(ban => {
      if (!filterText) return true;
      const u = ban.user();
      if (!u) return false;
      return u.displayName().toLowerCase().includes(filterText) || u.username().toLowerCase().includes(filterText);
    });
    return m("div", {
      className: "BanFromDiscussionModal-content"
    }, m("div", {
      className: "BanFromDiscussionModal-filterWrapper"
    }, m("i", {
      className: "fas fa-search BanFromDiscussionModal-filterIcon"
    }), m("input", {
      className: "FormControl BanFromDiscussionModal-filterInput",
      type: "text",
      placeholder: String(app.translator.trans('huseyinfiliz-discussion-ban.forum.modal.search_banned_placeholder')),
      value: this.bansFilter(),
      oninput: e => this.bansFilter(e.target.value)
    })), filteredBans.length === 0 ? m("p", {
      className: "BanFromDiscussionModal-empty"
    }, app.translator.trans('huseyinfiliz-discussion-ban.forum.modal.no_bans')) : m("ul", {
      className: "BanFromDiscussionModal-list"
    }, filteredBans.map(ban => {
      const user = ban.user();
      const bannedBy = ban.bannedBy();
      const createdAt = ban.createdAt();
      const bannedByName = bannedBy ? bannedBy.displayName() : String(app.translator.trans('core.lib.username.deleted_text'));
      return m("li", {
        className: "BanFromDiscussionModal-item",
        key: ban.id()
      }, m("div", {
        className: "BanFromDiscussionModal-item-avatar"
      }, m(Avatar, {
        user: user || null
      })), m("div", {
        className: "BanFromDiscussionModal-item-info"
      }, m("div", {
        className: "BanFromDiscussionModal-item-header"
      }, m("span", {
        className: "BanFromDiscussionModal-item-displayName"
      }, user ? user.displayName() : app.translator.trans('core.lib.username.deleted_text')), user && m("span", {
        className: "BanFromDiscussionModal-item-username"
      }, "@", user.username())), m("div", {
        className: "BanFromDiscussionModal-item-meta"
      }, createdAt && m("span", null, m("i", {
        className: "far fa-clock"
      }), " ", humanTime(createdAt)), m("span", null, m("i", {
        className: "fas fa-user-shield"
      }), ' ', app.translator.trans('huseyinfiliz-discussion-ban.forum.modal.banned_by', {
        username: bannedByName
      }))), ban.reason() && m("div", {
        className: "BanFromDiscussionModal-item-reason"
      }, m("i", {
        className: "fas fa-quote-left"
      }), " ", ban.reason())), m("div", {
        className: "BanFromDiscussionModal-item-actions"
      }, Button.component({
        className: 'Button Button--icon Button--danger BanFromDiscussionModal-deleteBtn',
        icon: 'fas fa-trash-alt',
        title: app.translator.trans('huseyinfiliz-discussion-ban.forum.modal.unban'),
        onclick: () => this.revoke(ban)
      })));
    })));
  }
  onQueryInput(value) {
    this.searchQuery = value;
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout);
      this.searchTimeout = null;
    }
    const trimmed = value.trim();

    // Invalidate any in-flight/queued request for every keystroke, and wipe
    // stale results immediately so an old query's results can never be shown
    // underneath the spinner (or after) a newer query.
    const requestId = ++this.searchRequestId;
    this.searchResults = [];
    if (trimmed.length < 2) {
      this.searching = false;
      this.isDropdownDismissed = false;
      this.showResults = false;
      m.redraw();
      return;
    }
    this.searching = true;
    this.showResults = true;
    this.isDropdownDismissed = false;
    m.redraw();
    this.searchTimeout = window.setTimeout(() => {
      this.searchTimeout = null;
      this.performSearch(trimmed, requestId);
    }, 300);
  }
  getDiscussionParticipantUsers() {
    const discussionId = this.attrs.discussion.id();
    const bannedUserMap = this.attrs.discussion.attribute('bannedUserMap') || {};
    const currentUserId = String(app.session.user?.id());
    const seen = new Set();
    const participants = [];
    app.store.all('posts').forEach(post => {
      if (post.discussion()?.id() !== discussionId) return;
      const u = post.user();
      if (!u || !u.id()) return;
      const id = String(u.id());
      if (id === currentUserId || u.isAdmin() || bannedUserMap[id] || seen.has(id)) return;
      seen.add(id);
      participants.push(u);
    });
    return participants;
  }
  performSearch(query, requestId) {
    const currentRequestId = requestId ?? ++this.searchRequestId;
    this.lastDispatchedRequestId = currentRequestId;
    app.request({
      method: 'GET',
      url: `${app.forum.attribute('apiUrl')}/users/discussion-participants/${this.attrs.discussion.id()}`,
      params: {
        filter: {
          q: query
        }
      }
    }).then(response => {
      // Ignore *displaying* results from a superseded search, but still
      // let the spinner-clearing logic in .finally() run for every
      // settled request so it never gets stuck.
      if (currentRequestId !== this.searchRequestId) {
        return;
      }
      const pushed = response ? app.store.pushPayload(response) : [];
      const apiUsers = Array.isArray(pushed) ? pushed : pushed ? [pushed] : [];

      // Also merge any matching participants already loaded in the store
      const q = query.toLowerCase();
      const localUsers = this.getDiscussionParticipantUsers().filter(u => {
        const username = u.username()?.toLowerCase() || '';
        const displayName = u.displayName()?.toLowerCase() || '';
        return username.includes(q) || displayName.includes(q);
      });

      // Combine and deduplicate
      const userMap = new Map();
      [...apiUsers, ...localUsers].forEach(user => {
        if (user && user.id()) {
          userMap.set(String(user.id()), user);
        }
      });
      const bannedUserMap = this.attrs.discussion.attribute('bannedUserMap') || {};
      const currentUserId = String(app.session.user?.id());
      this.searchResults = Array.from(userMap.values()).filter(user => {
        const uid = String(user.id());
        return uid !== currentUserId && !user.isAdmin() && !bannedUserMap[uid];
      });
      this.showResults = true;
      this.isDropdownDismissed = false;
      m.redraw();
    }).catch(() => {
      if (currentRequestId !== this.searchRequestId) {
        return;
      }

      // Fallback to local participants from loaded discussion posts
      const q = query.toLowerCase();
      this.searchResults = this.getDiscussionParticipantUsers().filter(u => {
        const username = u.username()?.toLowerCase() || '';
        const displayName = u.displayName()?.toLowerCase() || '';
        return username.includes(q) || displayName.includes(q);
      });
      this.showResults = true;
      this.isDropdownDismissed = false;
      m.redraw();
    }).finally(() => {
      // This is the only place that clears the spinner for a given
      // dispatched request, and it does so unconditionally as long as no
      // newer request has been dispatched since — independent of whether
      // this request's results were considered stale for display purposes
      // above. This guarantees the spinner can never get stuck open.
      if (currentRequestId === this.lastDispatchedRequestId) {
        this.searching = false;
        m.redraw();
      }
    });
  }
  clearSearch() {
    this.searchRequestId++;
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout);
      this.searchTimeout = null;
    }
    this.searchQuery = '';
    this.searchResults = [];
    this.searching = false;
    this.isDropdownDismissed = false;
    this.showResults = false;
    m.redraw();
  }
  selectUser(user) {
    this.selectedUser = user;
    this.clearSearch();
  }
  submit() {
    if (!this.selectedUser) return;
    this.loading = true;
    const trimmedReason = this.reason().trim();
    app.store.createRecord('discussion-bans').save({
      reason: trimmedReason.length > 0 ? trimmedReason : null,
      relationships: {
        discussion: this.attrs.discussion,
        user: this.selectedUser
      }
    }).then(ban => {
      this.loading = false;
      const userId = String(this.selectedUser.id());
      const map = {
        ...(this.attrs.discussion.attribute('bannedUserMap') || {})
      };
      map[userId] = Number(ban.id());
      const currentCount = this.attrs.discussion.attribute('discussionBansCount') ?? Object.keys(map).length - 1;
      const newCount = currentCount + 1;
      this.attrs.discussion.pushAttributes({
        bannedUserMap: map,
        discussionBansCount: newCount
      });
      app.store.all('posts').forEach(post => {
        if (post.discussion()?.id() === this.attrs.discussion.id() && String(post.user()?.id()) === userId) {
          post.pushAttributes({
            isHidden: true,
            hiddenAt: new Date().toISOString(),
            isDiscussionBanHidden: true
          });
        }
      });
      app.alerts.show({
        type: 'success'
      }, app.translator.trans('huseyinfiliz-discussion-ban.forum.modal.ban_success'));
      this.hide();
      m.redraw();
    }).catch(e => {
      this.loading = false;
      m.redraw();
      throw e;
    });
  }
  loadBans() {
    this.loadingBans = true;
    m.redraw();
    app.store.find('discussion-bans', {
      filter: {
        discussion: this.attrs.discussion.id()
      },
      include: 'user,bannedBy'
    }).then(bans => {
      this.bans = bans;
      this.loadingBans = false;
      m.redraw();
    }).catch(() => {
      this.loadingBans = false;
      m.redraw();
    });
  }
  revoke(ban) {
    if (!confirm(String(app.translator.trans('huseyinfiliz-discussion-ban.forum.modal.confirm_unban')))) {
      return;
    }
    const user = ban.user();
    const userId = user ? String(user.id()) : null;
    ban.delete().then(() => {
      this.bans = this.bans.filter(b => b.id() !== ban.id());
      if (userId) {
        const map = {
          ...(this.attrs.discussion.attribute('bannedUserMap') || {})
        };
        delete map[userId];
        const currentCount = this.attrs.discussion.attribute('discussionBansCount') ?? Object.keys(map).length + 1;
        const newCount = Math.max(0, currentCount - 1);
        this.attrs.discussion.pushAttributes({
          bannedUserMap: map,
          discussionBansCount: newCount
        });
        app.store.all('posts').forEach(post => {
          if (post.discussion()?.id() === this.attrs.discussion.id() && String(post.user()?.id()) === userId) {
            post.pushAttributes({
              isHidden: false,
              hiddenAt: null,
              isDiscussionBanHidden: false
            });
          }
        });
      }
      app.alerts.show({
        type: 'success'
      }, app.translator.trans('huseyinfiliz-discussion-ban.forum.modal.unban_success'));
      m.redraw();
    });
  }
}
flarum.reg.add('huseyinfiliz-discussion-ban', 'forum/components/BanFromDiscussionModal', BanFromDiscussionModal);